import { GESTION_OPERATIVA_SET_EXTRA_BON_EDITABLE } from './constants'

export function setExtraBonEditable(bool) {

    return (dispatch) =>{
      dispatch({
      type: GESTION_OPERATIVA_SET_EXTRA_BON_EDITABLE,
      data: { isExtraBonEditable: bool }
      })
  };
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SET_EXTRA_BON_EDITABLE) {
      return {
        ...state,
        isExtraBonEditable: action.data.isExtraBonEditable
        }
  }
  else {
    return state
  }      
}
